import type { StyleChildProps } from 'hb-builder/components/BuilderComponents/block/Strips/types/props';
import ButtonStyle from 'hb-builder/components/BuilderComponents/single/Button/ButtonSettings/Style/Button';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

interface StyleProps extends Omit<ComponentSettingsTab, 'item'> {
  item: DocumentItem;
}

const Buttons = ({ item, onChange }: StyleProps) => {
  const [, , button1, button2, button3, button4] = item.children || [];

  const buttonIds = [button1.id, button2.id, button3.id, button4.id];

  const handleBulkChange: StyleChildProps['handleBulkChange'] = ({
    settingKey,
    value,
    values,
  }) => {
    onChange({
      ids: buttonIds,
      settingKey,
      value,
      values,
    });
  };

  if (!item.attributes || !item.children) {
    return null;
  }

  return (
    <ButtonStyle
      defaultAttributes={item.attributes}
      item={{ ...item, children: [button1] }}
      onChange={handleBulkChange}
    />
  );
};

export default Buttons;
